import { Controller } from "@hotwired/stimulus"

// Handles product selection from routine log search results
// Dispatches a custom event that the routine_log_products_controller listens for
export default class extends Controller {
  selectProduct(event) {
    const button = event.currentTarget

    const productData = {
      routineId: button.dataset.routineId,
      timeOfDay: button.dataset.timeOfDay,
      productId: button.dataset.productId,
      productName: button.dataset.productName,
      productThumbnailUrl: button.dataset.productThumbnailUrl
    }

    // Dispatch custom event that routine_log_products_controller will listen for
    window.dispatchEvent(new CustomEvent('product:selected', {
      detail: productData
    }))
  }
}
